import { useActiveAccount } from '..';

export default function HideFromRolesAndTypes({ roles, types, children }) {
  const { hideFromRolesAndTypes } = useActiveAccount();

  return hideFromRolesAndTypes({ types, roles }) ? null : children;
}
